//auth
export const LOGIN = "/login";

// for main pages
export const LANDING = "/";
// export const MAIN_LAYOUT = "/";

//for contracting
export const GALLERY = "/gallery";
export const JOURNEY = "/journey";
export const POLICIES = "/policies_&_initiative";
export const ACTIVITY = "/activities/activity/:id";
export const VIEWGALLERY = "/gallery/galleryCollection/:id";
export const VIEWPARTY = "/party/:id";
export const VISION = "/vision";
export const ACTIVITIES = "/gallery/activities";
export const PARTY = "/party";
export const ARTICLES = "/articles";
export const ENDORSE = "/endorse";
